import { getUserEvents } from '@/store/thunks/events';
import { TEvent } from '@/types/events';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TEventsState = {
    list: TEvent[]
    isLoading: boolean
    isLoaded: boolean
}

const initialState: TEventsState = {
    isLoading: false,
    isLoaded: false,
    list: [],
};

export const userEventsSlice = createSlice({
    name: 'userEvents',
    initialState,
    reducers: {
        setIsLoading: (state) => {
            state.isLoading = true;
            state.isLoaded = false;
        },
        setIsLoaded: (state) => {
            state.isLoading = false;
            state.isLoaded = true;
        },
    },
    extraReducers: builder => {
        builder.addCase(getUserEvents.pending, userEventsSlice.caseReducers.setIsLoading);
        builder.addCase(getUserEvents.fulfilled, (state, action: PayloadAction<TEvent[]>) => {
            state.list = action.payload;
            userEventsSlice.caseReducers.setIsLoaded(state);
        });
        builder.addCase(getUserEvents.rejected, userEventsSlice.caseReducers.setIsLoaded);
    },
});
